export default "__VITE_ASSET__BXV1glaL__"